import { Component, OnInit, ViewEncapsulation, AfterViewChecked, Inject } from '@angular/core';
import { AnswerToCreateOrderRequest } from '../answer-to-create-order-request';
import { PaymentRequest } from '../payment-request';
import { ShoppingcartService } from '../shoppingcart.service';
import { PaymentOption } from '../typeofpayment/billing-options';
import { LoadingService } from '../loading-spinner/loading.service';
import { ApiRequestService } from '../../shared/api-request-service';
import { InitializePaymentResponse } from '../initialize-payment-response';
import { Router } from '@angular/router';
import { Material } from '../material';

@Component({
    selector: 'lib-order-confirmation',
    templateUrl: './order-confirmation.component.html',
    styleUrls: ['./order-confirmation.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrderConfirmationComponent implements OnInit {
    answerToCreateOrderRequest?: AnswerToCreateOrderRequest = {};
    paymentRequest?: PaymentRequest = {};
    paymentOptions?: string;
    apiUrl = '/order/pay';
    totalPrice = 0;


    constructor(
        private _loadingService: LoadingService,
        private _shoppingCartService: ShoppingcartService,
        private _router:Router

    ) {
    }

    ngOnInit(): void {
        const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        this.answerToCreateOrderRequest = this._shoppingCartService.answerToCreateOrderRequest;

        this.totalPrice = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;

        this.paymentOptions = JSON.parse(sessionStorage.getItem('paymentOption') as string) as string;

        //TODO somehow it doesn't navigate to home but doesn't show any totalPrice so it is definetely 0
        if(this.totalPrice === 0) {
            this._router.navigateByUrl('/');
        }
    }


    public get paymentOption(): typeof PaymentOption {
        return PaymentOption;
    }
}
